import { atom } from 'recoil'
import { ICurrency } from '~/src/repositories/SettingCurrency/models/SettingCurrency'

export type CurrencyAtomState = {
  currencies: ICurrency[]
  baseCurrency: { id: number; name: string } | undefined
  baseCurrencyUnit: string | undefined
  unitPosition: string | undefined
  isLoading: boolean
  error: string | null
}

export const initCurrencyState: CurrencyAtomState = {
  currencies: [],
  baseCurrency: undefined,
  baseCurrencyUnit: undefined,
  unitPosition: undefined,
  isLoading: false,
  error: null,
}

export const currencyState = atom<CurrencyAtomState>({
  key: 'currencyState',
  default: initCurrencyState,
})
